import { h, Fragment } from 'preact';
import { useEffect, useState, useRef } from 'preact/hooks';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const Flyout = ({
  children,
  positionClasses = 'right-0 left-0 bottom-0 lg:left-auto lg:bottom-auto lg:right-11 lg:top-[110px]',
  context = null,
  triggers = {},
  defaultOpen = false,
  classes = '',
  duration,
  bodyScrollLock = false,
  overlay = false,
}) => {
  const {
    openTriggerEl,
    closeTriggerEl,
    toggleEl,
    openTriggerElsArray,
    closeTriggerElsArray,
  } = triggers;

  const [isOpen, setIsOpen] = useState(defaultOpen);
  const flyoutRef = useRef(null);
  const handleOpenEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
    if (duration) {
      setTimeout(() => {
        setIsOpen(false);
      }, duration);
    }
    if (bodyScrollLock) {
      disableBodyScroll(flyoutRef.current, {
        // eslint-disable-next-line consistent-return
        allowTouchMove: (el) => {
          while (el && el !== document.body) {
            if (el === flyoutRef.current) {
              return true;
            }

            // eslint-disable-next-line no-param-reassign
            el = el.parentElement;
          }
        },
      });
    }
  };
  const handleCloseEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(false);
    if (bodyScrollLock) {
      enableBodyScroll(flyoutRef.current);
    }
  };
  const handleToggleEvent = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (openTriggerEl) openTriggerEl.addEventListener('click', handleOpenEvent);
    if (openTriggerElsArray)
      openTriggerElsArray.forEach((trigger) => {
        trigger.addEventListener('click', handleOpenEvent);
      });
    if (closeTriggerElsArray)
      closeTriggerElsArray.forEach((trigger) => {
        trigger.addEventListener('click', handleCloseEvent);
      });
    if (closeTriggerEl)
      closeTriggerEl.addEventListener('click', handleCloseEvent);
    if (toggleEl) toggleEl.addEventListener('click', handleToggleEvent);
    if (context) {
      document.addEventListener(`${context}:open`, handleOpenEvent);
      document.addEventListener(`${context}:close`, handleCloseEvent);
    }

    return () => {
      if (openTriggerEl)
        openTriggerEl.removeEventListener('click', handleOpenEvent);
      if (openTriggerElsArray)
        openTriggerElsArray.forEach((trigger) =>
          trigger.removeEventListener('click', handleOpenEvent),
        );
      if (closeTriggerElsArray)
        closeTriggerElsArray.forEach((trigger) => {
          trigger.removeEventListener('click', handleCloseEvent);
        });
      if (closeTriggerEl)
        closeTriggerEl.removeEventListener('click', handleCloseEvent);
      if (toggleEl) toggleEl.removeEventListener('click', handleToggleEvent);
      if (context) {
        document.removeEventListener(`${context}:open`, handleOpenEvent);
        document.removeEventListener(`${context}:close`, handleCloseEvent);
      }
    };
  }, [openTriggerEl, closeTriggerEl, toggleEl, openTriggerElsArray, context]);

  return (
    <Fragment>
      {isOpen && (
        <div
          className={`block w-full h-full fixed z-40 top-0 left-0 ${
            overlay && isOpen ? 'bg-black opacity-60' : ''
          }`}
          onClick={handleCloseEvent}
        ></div>
      )}
      <div
        className={`
          block
          ${classes}
          w-full lg:w-[400px]
          fixed
          z-40
          overflow-hidden
          bg-white
          transition-opacity
          duration-200
          ${positionClasses}
          ${
            isOpen ? 'lg:h-[600px] lg:max-h-[80%] opacity-100' : 'h-0 opacity-0'
          }
        `}
        ref={flyoutRef}
      >
        {children}
      </div>
    </Fragment>
  );
};

export default Flyout;
